import styled from '@emotion/styled';
import { FieldRoot, FormInputs } from '@lbcamden/lib-react';

export const ChildFormRoot = styled.div`
  ${FormInputs} {
    gap: ${({ theme }) => theme.spacing(4)} !important;
  }

  ${FieldRoot} {
    gap: ${({ theme }) => theme.spacing(1)} !important;
  }
`;
